import { trackError } from '@billy/track-error'
import { useMutation } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../../enums/queryKeys'
import { createEInvoicingKYCDocument } from '../query-api'
import { DocumentType } from '../types/documentType'

interface UseCreateEInvoiceKYCDocumentOptions {
  documentType: DocumentType
  onError?: (error: Error) => void
  onSuccess?: () => void
}

export interface CreateEInvoiceKYCDocumentParams {
  fileRef: string
  mimeType: string
  signature: string
}

export const useCreateEInvoiceKYCDocument = ({
  documentType,
  onError,
  onSuccess,
}: UseCreateEInvoiceKYCDocumentOptions) => {
  const { organization } = useUserOrganization()

  const { mutateAsync, isLoading } = useMutation(
    [QueryKeys.EInvoicingCreateKYCDocument, documentType],
    ({ fileRef, mimeType, signature }: CreateEInvoiceKYCDocumentParams) => {
      if (!organization?.id) {
        const errorMessage = 'Organization ID is required to create KYC document'
        trackError(errorMessage)
        return Promise.reject(new Error(errorMessage))
      }
      return createEInvoicingKYCDocument({
        documentType,
        fileRef,
        mimeType,
        network: 'PDP',
        signature,
        targetId: organization.id,
      })
    },
    { onError, onSuccess },
  )

  return {
    createKYCDocument: mutateAsync,
    isProcessing: isLoading,
  }
}
